module.exports = __webpack_public_path__ + "static/media/subscribers.9d7932f6.xml";


//////////////////
// WEBPACK FOOTER
// ./public/subscribers.xml
// module id = 1825
// module chunks = 1